<script setup lang="ts">
import {Button, Checkbox, SelectButton} from "@/Components/Library";
import Str from "@/Utils/Str";

const {totalActiveFilters} = defineProps<{totalActiveFilters?: number}>();

const filters = defineModel();
const emit = defineEmits(["apply", "clear"]);
</script>

<template>
    <div>
        <div class="mb-4">
            <h3 class="mb-2 font-semibold">Stimulus type</h3>
            <div class="grid grid-cols-1 gap-2 sm:grid-cols-2">
                <template v-for="type in ['document', 'slides', 'video', 'url', 'image', 'audio']" :key="type">
                    <div class="flex items-center gap-1">
                        <Checkbox :input-id="type" :name="type" binary v-model="filters.type[type]" />
                        <label :for="type">{{ Str.of(type).title() }}</label>
                    </div>
                </template>
            </div>
        </div>
        <div class="mb-4">
            <h3 class="mb-1 text-sm font-semibold">Ownership</h3>
            <SelectButton
                v-model="filters.ownership"
                :options="[
                    {label: 'Mine', value: 'mine'},
                    {label: 'Others', value: 'others'},
                ]"
                option-label="label"
                option-value="value"
                class="w-full"
            />
        </div>
        <div class="flex gap-2" v-auto-animate>
            <Button class="grow bg-askr-green text-white hover:brightness-110" @click="emit('apply')">Apply</Button>
            <Button
                v-if="totalActiveFilters"
                class="w-10 shrink-0 bg-red-600 text-white hover:brightness-110"
                @click="emit('clear')"
                :icon="{icon: 'mdi:filter-off-outline', width: '24'}"
            />
        </div>
    </div>
</template>

<style scoped></style>
